var map = {
	"./book.svg": 6612,
	"./calendar-alt-light.svg": 139,
	"./caret-right-solid.svg": 1106,
	"./chevron-down.svg": 3698,
	"./chevron-left.svg": 1865,
	"./chevron-right.svg": 260,
	"./chevron-up.svg": 2352,
	"./comments-alt-light.svg": 4685,
	"./doctor.svg": 6480,
	"./envelope-light.svg": 1687,
	"./facebook-round.svg": 8789,
	"./file-download-light.svg": 2082,
	"./flask.svg": 6332,
	"./folder-open-light.svg": 1028,
	"./heart-hand.svg": 4553,
	"./heart-handshake-light.svg": 3200,
	"./heart-handshake.svg": 9195,
	"./heart-solid.svg": 8894,
	"./heart.svg": 3944,
	"./instagram-round.svg": 1744,
	"./linkedin-round.svg": 758,
	"./medic.svg": 7083,
	"./minus-circle-light.svg": 6069,
	"./mobile.svg": 7252,
	"./pills.svg": 5266,
	"./play-circle-regular.svg": 1799,
	"./plus-circle-light.svg": 8711,
	"./plus-circle-solid.svg": 1266,
	"./quotes-primary.svg": 739,
	"./school-hat.svg": 850,
	"./search.svg": 8233,
	"./specials/doctor.svg": 5977,
	"./specials/friends.svg": 8125,
	"./specials/nurse.svg": 6585,
	"./specials/student.svg": 8008,
	"./thunderstorm.svg": 4675,
	"./times.svg": 8285,
	"./toggle.svg": 3726,
	"./twitter-round.svg": 1616,
	"./youtube-round.svg": 2640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2064;